import type { Project } from '@/types/project';

const STUDIO_PROJECT_CONTEXT_KEY = 'studio:project-context';

const isPositiveProjectId = (value: unknown) => {
  const id = Number(value);
  return Number.isFinite(id) && id > 0;
};

export const hasStudioProjectIdentity = (project: Pick<Project, 'id' | 'projectId'>) =>
  isPositiveProjectId(project.id) || isPositiveProjectId(project.projectId);

export const rememberStudioProject = (project: Project) => {
  if (!hasStudioProjectIdentity(project)) return;

  try {
    sessionStorage.setItem(STUDIO_PROJECT_CONTEXT_KEY, JSON.stringify(project));
  } catch {
    // The in-memory Studio store remains available when session storage is unavailable.
  }
};

export const getRememberedStudioProject = (): Project | null => {
  try {
    const rawProject = sessionStorage.getItem(STUDIO_PROJECT_CONTEXT_KEY);
    if (!rawProject) return null;

    const project = JSON.parse(rawProject) as Project;
    return hasStudioProjectIdentity(project) ? project : null;
  } catch {
    return null;
  }
};

export const clearRememberedStudioProject = () => {
  try {
    sessionStorage.removeItem(STUDIO_PROJECT_CONTEXT_KEY);
  } catch {
    // Storage cleanup is non-critical.
  }
};
